<template>
  <vue-tel-input
    :id="id"
    :disabled="disabled"
    v-bind="phoneProps"
    v-model="inputValue"
    @input="input"
    @enter="enter"
    @blur="blur"
    v-on:country-changed="changePlaceHolder"
    v-facade="'+# ### ###-##-##'"
  />
</template>

<script>
import formInputMixin from '../../mixins/formInputMixin'
import VueTelInput from 'vue-tel-input'
import Vue from 'vue'

Vue.use(VueTelInput)

export default {
  name: 'PhoneInput',
  mixins: [
    formInputMixin
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    id: {
      type: String,
      default: null
    },

    placeholder: {
      type: String,
      default: '+7 912 345-67-89'
    }
  },

  data: () => ({
    newInputValue: '',
    oldInputValue: '',
    dynamicPlaceholder: false
  }),

  computed: {
    phoneProps () {
      return {
        mode: 'international',
        defaultCountry: 'RU',
        preferredCountries: ['RU', 'BY', 'UA', 'KZ', 'UZ', 'AZ'],
        validCharactersOnly: true,
        autocomplete: 'on',
        disabled: this.disabled,
        dynamicPlaceholder: this.dynamicPlaceholder,
        placeholder: this.placeholder,
        inputId: null
      }
    }
  },

  methods: {
    changePlaceHolder ($value) {
      this.dynamicPlaceholder = $value.iso2 !== 'RU'
    },

    input ($event) {
      this.emitValue('input', $event)
    },

    blur ($event) {
      this.emitValue('blur', $event)
      this.emitChangeEvent($event)
    },

    enter () {
      this.emitValue('enter', this.inputValue)
      this.emitChangeEvent(this.inputValue)
    },

    emitChangeEvent ($event) {
      this.newInputValue = $event
      if (this.newInputValue === this.oldInputValue) {
        return
      }

      this.emitValue('change', $event)
      this.oldInputValue = this.newInputValue
    }
  }
}
</script>
